import { render } from "./GetGiftToolbar.vue?vue&type=template&id=5342b304&scoped=true&ts=true"
import script from "./GetGiftToolbar.vue?vue&type=script&lang=ts"
export * from "./GetGiftToolbar.vue?vue&type=script&lang=ts"

import "./GetGiftToolbar.vue?vue&type=style&index=0&id=5342b304&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5342b304"]])

export default __exports__